// extracted by mini-css-extract-plugin
export default {"title":"_24a1db4508","bld":"cb281cd6b1"};